export const environment = {
  production: true,
  version: require('../../package.json').version,
  apiUrl: 'https://api.elevamedical.com/api',
  wsUrl: 'wss://api.elevamedical.com/ws',
  factosExtensionId: 'cdpahhmdcifpppaoikjgcadknnagdenl',
};
